// @/services/StudentsClient.js
import { CandyClient } from "@cabysis/candy-client";
import { getToken } from "@/utilities/storage";
import { BACK_END_URL } from "@/utilities/config";

const studentsOptions = {
  baseUrl: `${BACK_END_URL}/student`,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
  getToken: () => getToken(),
};

export class StudentsClient extends CandyClient {
  constructor() {
    super(studentsOptions);
  }

  // Get all students enrolled in a specific course
  async getStudentsByCourse(courseId) {
    return this.get(`/all/course/${courseId}`);
  }

  // Get student profile (if needed)
  async getProfile() {
    return this.get("/profile");
  }

  // @/services/StudentsClient.js
async submitQuizAnswers(dto) {
  const token = getToken();
  return this.post("/submit-quiz", dto, {
    customHeaders: { 
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
}
}